import { makeStyles } from '@material-ui/core';
import { Grid, Typography } from '@material-ui/core/';
import React, { useState } from 'react';
import { required, SelectInput, TextInput } from 'react-admin';

import FundFamilyApi from '../../core/apis/FundFamilyApi';
import {
  isStringAlphaNumericUnderscoreHyphen,
  isStringOnlyUnderscoreHyphen
} from '../../core/utils/index';
import { fieldLengthValidator } from '../../core/utils/index';
import { fundFamilyStatus } from './FundFamilyLookups';

const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '0px !important'
  }
});

const fundFamilyNameMaxLength = 256;
const fundFamilyIDMaxLength = 20;
const fundFamilyAkaLength = 255;

const FundFamilySummary = props => {
  const [formErrors, setFormErrors] = useState({});
  const classes = useStyles();
  const { variant, creation } = props;

  /*
   * Verify that Fund Family ID is unique and alpha numeric,
   * also check if ID is not made just from Underscore and Hyphens
   */
  const validateFundFamilyId = async (value, allValues, props) => {
    if (props.active) {
      const idValid = isStringAlphaNumericUnderscoreHyphen(value);
      const isValueOnlyUnderscoreHyphen = isStringOnlyUnderscoreHyphen(value);
      let error;

      if (!idValid) {
        error =
          'Fund Family ID must be unique and only contain numbers, letters, underscore and hyphen symbols without any spaces';
      } else if (!isValueOnlyUnderscoreHyphen) {
        error =
          'Fund Family ID must contain at least one number or letter character';
      } else {
        const idExists = await FundFamilyApi.checkIdExists(value);

        if (idExists) {
          error = 'ID already exists';
        } else {
          error = undefined;
        }
      }
      setFormErrors({ ...formErrors, id: error });
      return error;
    }
    return formErrors.id;
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.headerContainer}>
          <Typography variant="h5">Fund Family Details</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="name"
            label="Fund Family Name"
            validate={[
              required(),
              fieldLengthValidator(fundFamilyNameMaxLength)
            ]}
            options={{ autoComplete: 'off' }}
            variant={variant}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="aka"
            label="A.K.A"
            options={{ autoComplete: 'off' }}
            variant={variant}
            validate={fieldLengthValidator(fundFamilyAkaLength)}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <SelectInput
            source="status"
            label="Status"
            choices={fundFamilyStatus}
            validate={[required()]}
            variant="standard"
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={3}>
          <TextInput
            source="id"
            label="Fund Family ID"
            validate={[
              required(),
              fieldLengthValidator(fundFamilyIDMaxLength),
              validateFundFamilyId
            ]}
            disabled={!creation}
            options={{ autoComplete: 'off' }}
            variant={variant}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default FundFamilySummary;
